import { OptionType } from "modules/common";

export const getDropdownOptions = <T extends string | number>(
    enumTranslation: Record<T, string> | Partial<Record<T, string>>
): OptionType<T>[] => {
    return Object.keys(enumTranslation).map(key => {
        const typedKey = isNaN(Number(key)) ? (key as T) : (Number(key) as T);

        return {
            label: enumTranslation[typedKey] ?? "",
            value: typedKey,
        };
    });
};

export const getDropdownValue = <T extends string | number>(
    enumValue: T | undefined,
    enumTranslation: Record<T, string> | Partial<Record<T, string>>
): OptionType<T> => {
    const typedKey = isNaN(Number(enumValue)) ? (enumValue as T) : (Number(enumValue) as T);

    return {
        label: enumTranslation[typedKey] ?? "",
        value: typedKey,
    };
};

export const getNoOptionsMessage = (
    isLoading: boolean,
    condition: boolean,
    message: string
): string => {
    if (isLoading) return "Učitavanje...";
    else if (condition) return message;
    else return "Nema podataka";
};
